export const enum Key {
  // Modifiers
  Shift = "Shift",
  Control = "Control",
  Alt = "Alt",

  // Letters
  A = "KeyA",
  B = "KeyB",
  C = "KeyC",
  D = "KeyD",
  E = "KeyE",
  F = "KeyF",
  G = "KeyG",
  H = "KeyH",
  I = "KeyI",
  J = "KeyJ",
  K = "KeyK",
  L = "KeyL",
  M = "KeyM",
  N = "KeyN",
  O = "KeyO",
  P = "KeyP",
  Q = "KeyQ",
  R = "KeyR",
  S = "KeyS",
  T = "KeyT",
  U = "KeyU",
  V = "KeyV",
  W = "KeyW",
  X = "KeyX",
  Y = "KeyY",
  Z = "KeyZ",

  // Numbers
  Digit0 = "Digit0",
  Digit1 = "Digit1",
  Digit2 = "Digit2",
  Digit3 = "Digit3",
  Digit4 = "Digit4",
  Digit5 = "Digit5",
  Digit6 = "Digit6",
  Digit7 = "Digit7",
  Digit8 = "Digit8",
  Digit9 = "Digit9",

  // Symbols
  Backslash = "Backslash",
  QuestionMark = "?",
  Backquote = "Backquote",
  Semicolon = "Semicolon",
  Slash = "Slash",

  // Special keys
  Backspace = "Backspace",
  Delete = "Delete",
  Enter = "Enter",
  Escape = "Escape",
  Space = "Space",
  Tab = "Tab",

  // Arrows
  ArrowDown = "ArrowDown",
  ArrowUp = "ArrowUp",
  ArrowLeft = "ArrowLeft",
  ArrowRight = "ArrowRight",

  // Page navigation
  Home = "Home",
  End = "End",
  PageUp = "PageUp",
  PageDown = "PageDown",
}

export const KeyDisplay: Record<Key, { default: string; mac?: string }> = {
  // Modifiers
  [Key.Shift]: { default: "⇧" },
  [Key.Alt]: { default: "Alt", mac: "⌥" },
  [Key.Control]: { default: "Ctrl", mac: "⌘" },

  // Letters
  [Key.A]: { default: "A" },
  [Key.B]: { default: "B" },
  [Key.C]: { default: "C" },
  [Key.D]: { default: "D" },
  [Key.E]: { default: "E" },
  [Key.F]: { default: "F" },
  [Key.G]: { default: "G" },
  [Key.H]: { default: "H" },
  [Key.I]: { default: "I" },
  [Key.J]: { default: "J" },
  [Key.K]: { default: "K" },
  [Key.L]: { default: "L" },
  [Key.M]: { default: "M" },
  [Key.N]: { default: "N" },
  [Key.O]: { default: "O" },
  [Key.P]: { default: "P" },
  [Key.Q]: { default: "Q" },
  [Key.R]: { default: "R" },
  [Key.S]: { default: "S" },
  [Key.T]: { default: "T" },
  [Key.U]: { default: "U" },
  [Key.V]: { default: "V" },
  [Key.W]: { default: "W" },
  [Key.X]: { default: "X" },
  [Key.Y]: { default: "Y" },
  [Key.Z]: { default: "Z" },

  // Numbers
  [Key.Digit0]: { default: "0" },
  [Key.Digit1]: { default: "1" },
  [Key.Digit2]: { default: "2" },
  [Key.Digit3]: { default: "3" },
  [Key.Digit4]: { default: "4" },
  [Key.Digit5]: { default: "5" },
  [Key.Digit6]: { default: "6" },
  [Key.Digit7]: { default: "7" },
  [Key.Digit8]: { default: "8" },
  [Key.Digit9]: { default: "9" },

  // Symbols
  [Key.Backslash]: { default: "\\" },
  [Key.QuestionMark]: { default: "?" },
  [Key.Backquote]: { default: "`" },
  [Key.Semicolon]: { default: ";" },
  [Key.Slash]: { default: "/" },

  // Special keys
  [Key.Backspace]: { default: "⌫" },
  [Key.Delete]: { default: "Del" },
  [Key.Enter]: { default: "↵" },
  [Key.Escape]: { default: "Esc" },
  [Key.Space]: { default: "Space" },
  [Key.Tab]: { default: "Tab" },

  // Arrows
  [Key.ArrowDown]: { default: "↓" },
  [Key.ArrowUp]: { default: "↑" },
  [Key.ArrowLeft]: { default: "←" },
  [Key.ArrowRight]: { default: "→" },

  // Page navigation
  [Key.Home]: { default: "Home" },
  [Key.End]: { default: "End" },
  [Key.PageUp]: { default: "PgUp" },
  [Key.PageDown]: { default: "PgDn" },
};
